/* global sageAjaxVars */
(function ($) {
    function delay(fn, ms)
    {
        let timer = 0;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(fn.bind(this, ...args), ms || 0);
        };
    }

    function shuffleProviderResults()
    {
        var container = document.querySelector('.provider-results[data-shuffle]');
        if (!container) {
            return;
        }
        try {
            var items = Array.prototype.slice.call(container.children);
            for (var i = items.length - 1; i > 0; i--) {
                var j = Math.floor(Math.random() * (i + 1));
                container.appendChild(items[j]);
                items.splice(j, 1);
            }
        } finally {
            // Reveal must run even if the shuffle throws: the CSS guard
            // (html.js .provider-results[data-shuffle]) hides this container.
            container.style.visibility = 'visible';
        }
    }

    $(document).ready(function () {
      //** region Provider Results Shuffle **//
        // Failsafe: never leave the results hidden if the shuffle fails to run.
        setTimeout(function () {
            var el = document.querySelector('.provider-results[data-shuffle]');
            if (el) {
                el.style.visibility = 'visible';
            }
        }, 2000);
        shuffleProviderResults();
      //** endregion Provider Results Shuffle **//

      //** region Show All Click **//
        $('#show-all').click(function (e) {
            e.preventDefault();
            $(this).closest('form').find('input[type=checkbox]').attr('checked', false);
            $(this).closest('form').find('input[type=text]').val('');
            $(this).closest('form').submit();
        });
      //** endregion Show All Clicks **//

      //** region Quiz Mail Button **//
        var mail_quiz_results_button = $('.mail-quiz-results');
        if (mail_quiz_results_button.length) {
            mail_quiz_results_button.click(function (e) {
                e.preventDefault();
                var button = $(this);
                var container = button.closest('div');
                var quiz = button.attr('href').replace('#', '');
                button.attr('disabled', true);
                if (quiz !== '') {
                    var send_data = {
                        action: 'send_quiz_email',
                        handler_ajax_nonce: sageAjaxVars.handler_ajax_nonce,
                        quiz_string: quiz,
                    };
                    $.post(sageAjaxVars.ajaxurl, send_data, function (response) {
                        response = JSON.parse(response);
                        if (response.status) {
                              button.remove();
                              container.html('Your results have been emailed. Thank you!');
                              container.addClass('callout').addClass('success');
                        } else {
                            console.log(response);
                            var message_box = container.find('.message-box');
                            if (!message_box.length) {
                                message_box = $('<div />').addClass('message-box');
                                container.prepend(message_box);
                            }
                            message_box.html('There was a problem sending your email. Please try again later');
                            message_box.addClass('callout').addClass('alert');
                        }
                    });
                }
            });
        }
      //** endregion Quiz Mail Button **//

      //** region Provider Filters **//
        var provider_filters = $('#provider-filters');
        if (provider_filters.length) {
            var currentRequest = null;
            var filter_func = function () {
                if (currentRequest) {
                    currentRequest.abort();
                }
                var provider_name = provider_filters.find('#provider-name').val();
                var genders = provider_filters.find('#genders-filter').find('input:checked');
                var provider_types = provider_filters.find('#provider-types-filter').find('input:checked');
                var specialties = provider_filters.find('#specialties-filter').find('input:checked');
              // var locations = provider_filters.find('#provider-locations-filter').find('input:checked');
                var cities = provider_filters.find('#provider-cities-filter').find('input:checked');
                var zip_code = $('#zip-code-field').val();
                var radius = $('#radius-field').val();

                var checked_genders = [];
                var checked_types = [];
                var checked_specialties = [];
                var checked_cities = [];
              // var checked_locations = [];

                var counter = 0;

                if (genders.length) {
                    genders.each(function () {
                        checked_genders[counter] = $(this).val();
                        counter++;
                    });
                }

                if (provider_types.length) {
                    counter = 0;
                    provider_types.each(function () {
                        checked_types[counter] = $(this).val();
                        counter++;
                    });
                }

                if (specialties.length) {
                    counter = 0;
                    specialties.each(function () {
                        checked_specialties[counter] = $(this).val();
                        counter++;
                    });
                }

                if (cities.length) {
                    counter = 0;
                    cities.each(function () {
                        checked_cities[counter] = $(this).val();
                        counter++;
                    });
                }
              /*
              if (locations.length) {
              counter = 0;
              locations.each(function () {
              checked_locations[counter] = $(this).val();
              counter++;
              });
              }*/

                var filter_data = {
                    action: 'filter_provider_list',
                    provider_name: provider_name,
                    genders: checked_genders,
                    provider_types: checked_types,
                    specialties: checked_specialties,
                    cities: checked_cities,
                  // locations: checked_locations,
                    base_url: window.location.pathname,
                    zip_code: zip_code,
                    radius: radius,
                };
                var provider_contents = $('#provider-lists-contents');
                provider_contents.addClass('is-loading').attr('aria-busy', 'true');
                currentRequest = $.ajax({
                    url: sageAjaxVars.ajaxurl,
                    type: 'POST',
                    data: filter_data,
                    timeout: 30000,
                    success: function (response) {
                        currentRequest = null;
                        try {
                            response = JSON.parse(response);
                        } catch (e) {
                            console.error('[ProviderFilter] JSON parse failed', e);
                            provider_contents.removeClass('is-loading').attr('aria-busy', 'false');
                            return;
                        }

                        if (response.status) {
                            provider_contents.html('').html(response.content);
                            shuffleProviderResults();
                            provider_contents.removeClass('is-loading').attr('aria-busy', 'false');

                            if (typeof response.heading_text === 'string') {
                                $('.provider-results-count').text(response.heading_text);
                            }
                            if (typeof response.total !== 'undefined') {
                                $('.provider-results-count-inline').text(response.total);
                            }
                            provider_contents.find('.popup-gallery').modaal({
                                type: 'image',
                            });

                            provider_contents.find('.popup-video').modaal({
                                type: 'video',
                            });

                            provider_contents.find('.popup-inline').modaal({});

                            provider_contents.find('[data-tooltip]').each(function () {
                                new window.Foundation.Tooltip($(this));
                            });

                            window.history.pushState({}, $('title').html(), response.url);
                        } else {
                            console.warn('[ProviderFilter] Response status false', response);
                            provider_contents.removeClass('is-loading').attr('aria-busy', 'false');
                        }
                    },
                    error: function (xhr, status, error) {
                        console.error('[ProviderFilter] AJAX error', {
                            status: status,
                            error: error,
                            httpStatus: xhr.status,
                        });
                        currentRequest = null;
                        provider_contents.removeClass('is-loading').attr('aria-busy', 'false');
                    },
                });
            };

            provider_filters.find('input[type=checkbox]').click(filter_func);
            provider_filters.find('input#provider-name').change(filter_func);
            provider_filters.find('input#provider-name').keyup(delay(filter_func, 500));
            provider_filters.find('input#zip-code-field').keyup(delay(filter_func, 500));
            provider_filters.find('select#radius-field').change(filter_func);
        }

        var arr_names = window.provider_names;
        $('#provider-name').autocomplete({
            source: arr_names,
            select: filter_func,
        });
      //** endregion Provider Filters **//

      //** region Search Autocomplete **//
        var searchInputs = $('.search-autocomplete');
        if (searchInputs.length && sageAjaxVars.ajaxurl) {
            searchInputs.each(function() {
                var $input = $(this);

                // Append the dropdown to the nearest positioned ancestor (overlay panel
                // on overlay, body on search page). This keeps the dropdown in the
                // same stacking context as the input so it's not hidden behind the overlay.
                var $parent = $input.closest('.search-overlay__panel');
                var appendTo = $parent.length ? $parent : 'body';

                $input.autocomplete({
                    source: function(request, response) {
                        $.getJSON(sageAjaxVars.ajaxurl, {
                            action: 'search_autocomplete',
                            term: request.term,
                            blog_id: sageAjaxVars.blog_id,
                        }).done(function(data) {
                            response(data);
                        }).fail(function() {
                            response([]);
                        });
                    },
                    minLength: 2,
                    appendTo: appendTo,
                    select: function(event, ui) {
                        $input.val(ui.item.value);
                        $input.closest('form').submit();
                    },
                });
            });
        }
      //** endregion Search Autocomplete **//

      //** region Employee Filters **//
        var employee_filters = $('#employee-filters');
        if (employee_filters.length) {
            var employee_filter_func = function () {
                var first_name = employee_filters.find('#first-name').val();
                var last_name = employee_filters.find('#last-name').val();
                var employee_title = employee_filters.find('#employee-title').val();
                var locations = employee_filters.find('#employee-locations-filter').find('input:checked');
                var checked_locations = [];

                if (locations.length) {
                    var counter = 0;
                    locations.each(function () {
                        checked_locations[counter] = $(this).val();
                        counter++;
                    });
                }

                var filter_data = {
                    action: 'filter_employee_list',
                    handler_ajax_nonce: sageAjaxVars.handler_ajax_nonce,
                    first_name: first_name,
                    last_name: last_name,
                    employee_title: employee_title,
                    locations: checked_locations,
                    base_url: window.location.pathname,
                };
                $.post(sageAjaxVars.ajaxurl, filter_data, function (response) {
                    response = JSON.parse(response);

                    if (response.status) {
                        var employee_contents = $('#employee-lists-contents');
                        employee_contents.html('').html(response.content);
                        window.history.pushState({}, $('title').html(), response.url);
                    }
                });
            };

            employee_filters.find('input[type=checkbox]').click(employee_filter_func);
            employee_filters.find('input#first-name').change(employee_filter_func);
            employee_filters.find('input#first-name').keyup(delay(employee_filter_func, 500));
            employee_filters.find('input#last-name').change(employee_filter_func);
            employee_filters.find('input#last-name').keyup(delay(employee_filter_func, 500));
            employee_filters.find('input#employee-title').change(employee_filter_func);
            employee_filters.find('input#employee-title').keyup(delay(employee_filter_func, 500));
        }
      //** endregion Employee Filters **//

      //** region Provider Filter Modal **//
        (function () {
            var modal = document.getElementById('provider-filter-modal');
            var trigger = document.querySelector('.provider-filter-modal-trigger');
            if (!modal || !trigger) return;

            // Matches Foundation $breakpoints: medium = 832px. Below this the
            // sidebar becomes a dialog; at/above it, it's a normal sidebar.
            var mql = window.matchMedia('(max-width: 831px)');
            var lastFocused = null;

            function getFocusable() {
                return modal.querySelectorAll(
                    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]),' +
                    ' select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
                );
            }

            function isOpen() {
                return modal.classList.contains('is-open');
            }

            function openModal(e) {
                if (e) e.preventDefault();
                if (!mql.matches) return; // no-op on desktop

                lastFocused = document.activeElement;
                modal.setAttribute('aria-hidden', 'false');
                document.body.classList.add('provider-filter-modal-open');
                trigger.setAttribute('aria-expanded', 'true');

                // Force reflow so the CSS transition runs
                // eslint-disable-next-line no-unused-expressions
                modal.offsetHeight;

                requestAnimationFrame(function () {
                    modal.classList.add('is-open');
                    var closeBtn = modal.querySelector('.provider-filter-modal__close');
                    if (closeBtn) closeBtn.focus();
                });
            }

            function closeModal() {
                if (!isOpen()) return;
                modal.classList.remove('is-open');
                modal.setAttribute('aria-hidden', 'true');
                document.body.classList.remove('provider-filter-modal-open');
                trigger.setAttribute('aria-expanded', 'false');

                if (lastFocused && typeof lastFocused.focus === 'function') {
                    lastFocused.focus();
                }
            }

            // Apply ARIA state based on viewport — at desktop the element is
            // just a sidebar and should not present as a dialog.
            function syncAria() {
                if (mql.matches) {
                    modal.setAttribute('role', 'dialog');
                    modal.setAttribute('aria-modal', 'true');
                    if (!isOpen()) {
                        modal.setAttribute('aria-hidden', 'true');
                    }
                } else {
                    modal.removeAttribute('role');
                    modal.removeAttribute('aria-modal');
                    modal.removeAttribute('aria-hidden');
                    // If viewport grows while modal is open, clean up the open state.
                    if (isOpen()) {
                        modal.classList.remove('is-open');
                        document.body.classList.remove('provider-filter-modal-open');
                        trigger.setAttribute('aria-expanded', 'false');
                    }
                }
            }

            syncAria();
            if (typeof mql.addEventListener === 'function') {
                mql.addEventListener('change', syncAria);
            } else if (typeof mql.addListener === 'function') {
                mql.addListener(syncAria); // Safari <14
            }

            trigger.addEventListener('click', openModal);

            modal.addEventListener('click', function (e) {
                if (e.target.closest && e.target.closest('[data-provider-filter-close]')) {
                    closeModal();
                }
            });

            document.addEventListener('keydown', function (e) {
                if (!isOpen()) return;

                if (e.key === 'Escape' || e.keyCode === 27) {
                    e.preventDefault();
                    closeModal();
                    return;
                }

                if (e.key === 'Tab' || e.keyCode === 9) {
                    var focusable = getFocusable();
                    if (!focusable.length) return;
                    var first = focusable[0];
                    var last = focusable[focusable.length - 1];

                    if (e.shiftKey && document.activeElement === first) {
                        e.preventDefault();
                        last.focus();
                    } else if (!e.shiftKey && document.activeElement === last) {
                        e.preventDefault();
                        first.focus();
                    }
                }
            });
        })();
      //** endregion Provider Filter Modal **//
    });
})(jQuery);
